module.exports = __webpack_public_path__ + "static/media/signage-industrial-img10.9d0b06bf.jpg";